module.exports = __webpack_public_path__ + "static/media/Footing.fad21e12.png";